<template>
  <div>
    <t-form ref="form" @submit.prevent>
      <ExecutionPeriodRadioFormPart @result="onResult" @change="onChange" />
    </t-form>

    <FormErrorMessages :error-messages="errorMessages" />
  </div>
</template>

<script>
import AbstractFormStep from 'chimera/all/components/form/steps/AbstractFormStep'
import FormErrorMessages from 'chimera/all/components/form/FormErrorMessages'
import ExecutionPeriodRadioFormPart from 'chimera/all/components/form/parts/executionPeriod/ExecutionPeriodRadioFormPart.vue'
import NextStep from '~/pages/offertes-aanvragen/binnen-of-buiten-schilderwerk.vue'

export default {
  name: 'ExecutionPeriodRadioFormStep',

  components: {
    ExecutionPeriodRadioFormPart,
    FormErrorMessages,
  },

  extends: AbstractFormStep,

  /**
   * @returns {willTransitionOnValid: boolean}
   */
  data() {
    return {
      willTransitionOnValid: true,
    }
  },

  /**
   * Pass through the submit event given from FormModal
   */
  created() {
    this.$nuxt.$on('submit', this.onSubmit)
  },

  /**
   * Clean up before component is destroyed
   */
  destroyed() {
    this.$nuxt.$off('submit')
  },

  methods: {
    /**
     * Transition
     */
    transition() {
      this.routeTo(NextStep)
    },
  },
}
</script>
